import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../components/sections/TopNav';
import SiteFooter from '../components/sections/SiteFooter';

const PaymentCancel = () => (
  <div className="min-h-screen bg-black text-white" data-testid="payment-cancel-page">
    <TopNav />
    <main className="max-w-lg mx-auto px-4 py-16 text-center">
      <p className="text-zinc-500 text-[10px] font-black uppercase tracking-[0.3em] mb-2">Checkout cancelled</p>
      <h1 className="text-3xl font-black mb-3" style={{ fontFamily: 'Georgia, serif' }}>No worries.</h1>
      <p className="text-zinc-400 text-sm mb-6">
        You weren&apos;t charged. Have another look at the plans or come back later.
      </p>
      <div className="flex items-center justify-center gap-3">
        <Link to="/subscribe" className="bg-red-600 hover:bg-red-500 text-white font-black text-xs uppercase tracking-[0.3em] px-5 py-3 rounded">
          Back to plans
        </Link>
        <Link to="/" className="text-zinc-400 hover:text-white underline text-sm">Home</Link>
      </div>
    </main>
    <SiteFooter />
  </div>
);

export default PaymentCancel;
